import React from "react";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import Heart from "./Heart.jsx";
class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            liked: true,
        };
        this.toggleLike = () => {
            this.setState((state) => ({
                liked: !state.liked,
            }));
        };

        this.inputref = React.createRef();
    }
    render() {
        return (
            <div>
                <div className="main-boxes">
                    <div className="main-cards">
                        <div className="main-box">
                            <Heart />
                            <div className="card-image">
                                <img src={this.props.imgLink} alt="" />
                            </div>
                            <div className="price">
                                <h3>{this.props.price}</h3>
                                <p>{this.props.itemName}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
class Sell extends React.Component {
    render() {
        return (
            <div className="Main-sell ">
                <div className="main-sell-box">
                    <h3>Want to see your Stuff here</h3>
                    <br />
                    <p>
                        Make some extra cash by selling things in your
                        community.Go on, it's quick and easy
                    </p>
                    <center>
                        <button className="btn">Start selling</button>
                    </center>
                </div>
            </div>
        );
    }
}
export { Sell, Card };
